/*
 * Base Google Map example
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Location } from "./Constants";
import { url } from '../image';

import GoogleMap from 'google-map-react';

const styleMarker ={
  position: "absolute",
  top: "-20px",
  width: "20px",
  height: "20px",
  padding: "0px 3px 3px 0",
  borderRadius: "50% 50% 50% 0%",
  boxShadow: "-1px 1px 4px 0px rgba(0, 0, 0, 0.5)",
  background: "#00ae9e",
  transform: "translate(-50%, -50%) rotateX(20deg) rotateZ(-45deg)",
  transformOrigin: "50% 50%"
}

const styleImageMarker = {
  position: "absolute",
  width: 14,
  color: "white",
  fontSize: 8,
  left: 3,
  top: 3,
  transform: "rotate(45deg)"
}

const Marker = () => <div style={styleMarker}><img style={styleImageMarker} alt="Ynov" src={url("favicon.png")}/></div>;

export default class Map extends Component {
  static propTypes = {
    center: PropTypes.array,
    zoom: PropTypes.number,
  };

  static defaultProps = {
    center: [44.854165, -0.566282],
    zoom: 15,
    marker: {lat: 44.854165, lng: -0.566282}
  };

  render() {
    let { center, zoom, marker } = this.props;
    if(this.props.location){
      const location = Location.parse(this.props.location);
      if(location.lat && location.lng) {
        center = [ location.lat, location.lng ];
        marker = { lat: location.lat, lng: location.lng};
      }
    }

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <GoogleMap
                {...this.props}
                bootstrapURLKeys={{ key: "AIzaSyC97niQGYgHi5ARcnOxzt7QjZr7jG1QJuY", libraries: 'places' }}
                center={ center }
                style={{opacity : this.props.disabled ? 0.5 : 1}}
                zoom={ zoom }
                >
                { this.props.location ? 
                    <Marker                      
                      lat={marker.lat}
                      lng={marker.lng}/>
                  : this.props.children }
            </GoogleMap>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/helper/map/map.js